import { createFileRoute, Outlet } from "@tanstack/react-router";
import appCss from "@/styles/app.css?url";
import { AdminDialogProvider } from "@/components/ui/admin-dialog-context";

/**
 * Layout route for the whole /admin subtree. Its only job is to attach the
 * app (non-critical) stylesheet in the document head, so admin utility CSS
 * never ships on public routes.
 */
export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
    links: [{ rel: "stylesheet", href: appCss }],
  }),
  component: () => (
    <AdminDialogProvider>
      <Outlet />
    </AdminDialogProvider>
  ),
});
